module.exports = __webpack_public_path__ + "img/8.7855f484.png";